class BundleProducts extends HHBaseElement {
  constructor() {
    super()

    this._handleVariantChange = this._handleVariantChange.bind(this)
    this._handleAddToCart = this._handleAddToCart.bind(this)

    this.bundleDiscountType = this.getAttribute('data-discount-type')
    this.bundleDiscountAmount = this.getAttribute('data-discount-amount')
    this.bundleVariantId = this.getAttribute('data-bundle-variant-id')
    this.currency = this.getAttribute('data-currency') || 'USD'
    this.locale = this.getAttribute('data-locale') || 'en-US'
    this.fixedDiscountPrice = this.getAttribute('data-fixed-discount-price')
  }

  _calculateBundlePrice() {
    let priceContainers

    if (this.getAttribute('data-save-with-sets') !== null) {
      priceContainers = this.querySelectorAll('[data-bundle-price]')
    } else {
      priceContainers = document.querySelectorAll('[data-bundle-price]')
    }

    const bundlePrice = this._getBundlePrice();
    let bundleRegPrice = bundlePrice.total || 0;
    let bundleDiscountPrice = bundlePrice.price || 0;

    if (bundleRegPrice > 0 && priceContainers.length > 0) {
      priceContainers.forEach(priceContainer => {
        priceContainer.textContent = this._formatPrice(bundleDiscountPrice) || '0.00'
      })
    }

    return bundleDiscountPrice;
  }

  _getBundleTotal() {
    let price = 0;

    const wrappers = [...this.querySelectorAll('.bundle-product-wrapper')]
    wrappers.forEach(wrapper => {
      const priceElement = wrapper.querySelector('[data-selected-variant-price]')
      const itemPrice = priceElement ? parseFloat(priceElement.getAttribute('data-selected-variant-price')) : 0;
      price += itemPrice * (parseInt(wrapper.getAttribute('data-qty')) || 1);
    });
    return price;
  }

  _getBundlePrice() {
    let total = this._getBundleTotal();

    let price = 0;

    if (this.bundleDiscountType === 'fixed price' && this.fixedDiscountPrice) {
      price = parseFloat(this.fixedDiscountPrice) / 100
    }

    if (this.bundleDiscountType === 'dollar amount off total') {
      price = total - Math.floor(parseFloat(this.bundleDiscountAmount))
    }

    if (this.bundleDiscountType === 'percentage off total') {
      price = total - (total * (parseFloat(this.bundleDiscountAmount) / 100))
    }

    return {
      total: total,
      price: price,
    };
  }

  _formatPrice(price) {
    return new Intl.NumberFormat(this.locale, {
        style: 'currency',
        currency: this.currency,
      }).format(price)
  }

  _handleVariantChange(event) {
    if (!this.contains(event.target) || !event.target.matches('[data-variant-selector]')) {
      return
    }

    const input = event.target
    const variantId = input.dataset.variantId
    const wrapper = input.closest('.bundle-product-wrapper')
    if (wrapper) {
      const dynamicSection = wrapper.querySelector('dynamic-section')
      dynamicSection.setAttribute('params', `?variant=${variantId}`)
      if (input.checked) {
        wrapper.setAttribute('data-selected-variant', variantId)
      }
      this._calculateBundlePrice()
    }

    this._updateButtonState()
  }

  async _handleAddToCart(event) {
    event.preventDefault()

    if (this.$addToCartButton.disabled) {
      return
    }

    const items = []

    const components = [];
    const wrappers = [...this.querySelectorAll('.bundle-product-wrapper')]
    wrappers.forEach(wrapper => {
      const id = wrapper.getAttribute('data-selected-variant');
      if (id) {
        const bundleData = JSON.parse(wrapper.querySelector('.bundle-product-data')?.textContent || '{}');
        const priceElement = wrapper.querySelector('[data-selected-variant-price]')
        const itemPrice = priceElement ? parseFloat(priceElement.getAttribute('data-selected-variant-price')) : 0;
        components.push({
           v: id,
           q: parseInt(wrapper.getAttribute('data-qty'), 10) || 1,
           p: wrapper.getAttribute('data-id') || '',
           op: itemPrice * 100,
           uid: bundleData.variants?.[id].uid,
        });
      }
    })

    const bundlePrice = this._getBundlePrice();
    items.push({
      id: this.bundleVariantId,
      quantity: 1,
      properties: {
        _is_bundle: 'true',
        _bundle_items: JSON.stringify({
          data: components,
        }),
        _bundle_price: `${bundlePrice.price}`,
        _bundle_original_price: `${bundlePrice.total}`
      },
    });

    try {
      await window.__CART__CONTROLLER__.add(items, false)
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'))

      this._updateButtonState()
    } catch (error) {
      console.error('Error adding bundle to cart:', error)
    }
  }

  _updateButtonState(state = false, unavailable = false) {
    if (!this.$addToCartButton) return

    this.$addToCartButton.disabled = state

    if (this.$addToCartStickyButton) {
      this.$addToCartStickyButton.disabled = state
    }

    if (unavailable) {
      this.$addToCartButton.classList.add('out-of-stock');
    } else {
      this.$addToCartButton.classList.remove('out-of-stock');
    }
  }

  connectedCallback() {
    this.$addToCartButton = document.querySelector(this.getAttribute('data-add-to-cart-selector'))
    this.$addToCartStickyButton = document.querySelector('.add-to-bundle')
    this._updateButtonState()
    this._attachListeners()
    this._calculateBundlePrice()
  }

  disconnectedCallback() {
    this._removeListeners()
  }

  _attachListeners() {
    this.addEventListener('dynamic-section::loaded', this._validateProducts)
    this.addEventListener('dynamic-section::loaded', this._calculateBundlePrice)
    this.addEventListener('dynamic-section::loaded', this._validateVariants)
    this.$addToCartButton.addEventListener('click', this._handleAddToCart)

    const wrappers = this.querySelectorAll('.bundle-product-wrapper')
    wrappers.forEach(wrapper => {
      wrapper.addEventListener('change', this._handleVariantChange, true)
    })
  }

  _validateProducts() {
    const disabledVariant = this.querySelector('[data-unavailable="true"]')
    if (disabledVariant) {
      this._updateButtonState(true, true);
    } else {
      this._updateButtonState(false);
    }
  }

  _validateVariants() {
    const wrappers = this.querySelectorAll('.bundle-product-wrapper')

    wrappers.forEach(wrapper => {
      const rawVariantsData = wrapper.getAttribute('data-bundle-variants')
      const availableBundleVariants = rawVariantsData.split(',').filter(v => !!v)

      wrapper.querySelectorAll('[data-variant-selector]').forEach(input => {
        const variantId = input.dataset.variantId

        if (!availableBundleVariants.includes(variantId)) {
          input.closest('.js-input-wrapper')?.remove()
        }
      })
    })
  }

  _removeListeners() {
    this.$addToCartButton.removeEventListener('click', this._handleAddToCart)

    const wrappers = this.querySelectorAll('.bundle-product-wrapper')
    wrappers.forEach(wrapper => {
      wrapper.removeEventListener('change', this._handleVariantChange, true)
    })
  }
}

window.customElements.define('bundle-products', BundleProducts)
